module.exports = __webpack_public_path__ + "assets/img/34_710_big.64feb78d.jpg";